import React from 'react';
import {
  SafeAreaView,
  View,
  StyleSheet,
  Image,
  Text,
  Linking,
  TouchableOpacity,
  Platform,
  useWindowDimensions
} from 'react-native';

import MyText from './MyText';
import css from './Style'
import axios from 'axios';

import AsyncStorage from '@react-native-async-storage/async-storage';

export default function SideMenu(props) {
    const {height, width} = useWindowDimensions();

    const Logout = () => {
        props.bottomSheet.current?.dismiss();
        axios.get('/api/user/logout.php')
        .then(async() => {
            await AsyncStorage.removeItem('token');
            props.setUser(null);
            props.navigation?.push('Landing Page');
        })
    }

    const Touch = (name) => {
        return (
            <TouchableOpacity style={[styles.touchable, {backgroundColor: props.route.name===name?'#D0D0D0':null}]} onPress={() => {props.navigation?.push(name);}}>
                <View style={styles.labelContainer}>
                    <MyText style={[styles.label, props.route.name===name?css.bold:null]}>
                        {name}
                    </MyText>
                </View>
            </TouchableOpacity>
        )
    }

    return (
        <View style={{flex: 1, paddingVertical: 10, marginBottom: 0, backgroundColor: '#F2EFF8'}}>
        {
            props.user &&
            <TouchableOpacity style={[styles.touchable, {backgroundColor: props.route.name==='My Profile'?'#D0D0D0':null}]} onPress={() => {props.navigation?.push('My Profile');}}>
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                    <View style={styles.labelContainer}>
                        <MyText style={[styles.label, props.route.name==='My Profile'?css.bold:null]}>
                            {props.user.firstName} {props.user.lastName}
                        </MyText>
                    </View>
                </View>
            </TouchableOpacity>
        }
        {
            props.user && !props.user.isVGroup?
            <>
                {Touch('My Requests')}
                {Touch('New Request')}
                {Touch('Dashboard')}
                {Touch('Documents')}
                {Touch('My Notifications')}
            </>
            :<></>
        }
        {
            props.user && props.user.isVGroup?
            <>
                {Touch('Manage Requests')}
                {Touch('New Request')}
                {Touch('Manage Users')}
                {Touch('Dashboard')}
                {Touch('Documents')}
                {Touch('My Notifications')}
            </>
            :<></>
        }
        {
            props.user &&
            <TouchableOpacity style={styles.touchable} onPress={Logout}>
                <View style={styles.labelContainer}>
                    <MyText style={styles.label}>
                        Logout
                    </MyText>
                </View>
            </TouchableOpacity>
        }
        </View>
    )
}

const styles = StyleSheet.create({
    background: {
        display: 'flex',
        backgroundColor: '#F6F4F9',
        padding: 10,
        flexDirection: 'row',
        alignItems: 'center',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        borderTopWidth: 4,
        borderColor: '#e9e3f0',
        // boxShadow: '0px 0px 15px #e9e3f0',
        justifyContent: 'space-around',
        paddingBottom: Platform.OS === 'ios' ? 20 : 10
      },
      touchable: {
        paddingLeft: 30,
        position: 'relative',
        flexDirection: 'row',
      },
      icon: {
        width: 30,
        height: 30,
        resizeMode: 'contain'
      },
      vectorIcon: {
        width: 30,
        height: 30,
        resizeMode: 'contain',
        paddingTop: 3
      },
      label: {
        color: '#4D4D4D',
        fontSize: 12,
        marginVertical: 10
      }
});
